import type { IconSvgObject } from './types';

const MailUnlock02Icon: IconSvgObject = [
  ["path", { d: "M11.5 19H4C2.89543 19 2 18.1046 2 17V5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.5 15.5H15V21H22V15.5H20.5H16.5ZM16.5 15.5V14C16.5 12.8954 17.3954 12 18.5 12C19.2403 12 19.8866 12.4022 20.2324 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 7L10.9923 9.91215C11.615 10.2754 12.385 10.2754 13.0077 9.91215L18 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default MailUnlock02Icon;
